import React from "react";

const useLiftStateValue = (GetSelectedValue, UiValue, SelectableDataArray) => {
  React.useEffect(() => {
    if (GetSelectedValue) {
      GetSelectedValue({
        ItemContent: UiValue,
        ItemValue: SelectableDataArray?.filter(
          (DataArray) => DataArray?.ItemContent === UiValue
        )[0]?.ItemValue,
      });
    }
  }, [UiValue]);
};

export default useLiftStateValue;
